import { render, staticRenderFns } from "./EmailTextModal.vue?vue&type=template&id=387dac9b"
import script from "./EmailTextModal.vue?vue&type=script&lang=js"
export * from "./EmailTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports